import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  makeStyles,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SettingsIcon from '@material-ui/icons/Settings';
import { Controller, useForm } from 'react-hook-form';
import SendIcon from '@material-ui/icons/Send';
import flespiDeviceService from '../../../../services/FlespiDeviceService';
import toast from 'react-hot-toast';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: '#757575',
    fontWeight: '700'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.secondary
  },
  accordionSummaryDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  settingsDiv: {
    marginRight: '12px'
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column'
  },
  accordionDetailsItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: '1rem'
  }
}));

const odometerOptions = [
  { value: 'stop', label: 'Stop', id: 0 },
  { value: 'start', label: 'Start', id: 1 }
];

const TrackingOnDemandMode = ({ trackingOnDemandModeRecord }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm({
    defaultValues: {
      type: trackingOnDemandModeRecord[0]?.current?.type
    }
  });

  const handleOdometer = (data) => {
    setLoading(true);

    const trackingOnDemandModePayload = {
      deviceId: trackingOnDemandModeRecord[0]?.device_id,
      settSelector: 'on_demand_mode',
      properties: {
        type: data.type ?? null
      }
    };

    // eslint-disable-next-line no-console, no-undef
    console.log('trackingOnDemandModePayload', trackingOnDemandModePayload);

    flespiDeviceService
      .updateFlespiDeviceSetting(trackingOnDemandModePayload)
      .then((data) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('data is:', data);
        toast.success('Successfully updated tracking on demand mode settings.');
      })
      .catch((error) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('error', error?.response?.data?.message);
        toast.error(error?.response?.data?.message || 'Unable to update tracking on demand mode settings.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div style={{ marginBottom: '1rem' }}>
      <form onSubmit={handleSubmit(handleOdometer)}>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <div className={classes.accordionSummaryDiv}>
              <div className={classes.settingsDiv}>
                <SettingsIcon />
              </div>

              <div>
                <Typography className={classes.heading}> Tracking on demand mode</Typography>
                <Typography className={classes.secondaryHeading}>
                  Push device to start to generate high priority records and initiate data sending to server
                </Typography>
              </div>
            </div>
          </AccordionSummary>

          <Divider />

          <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography style={{ color: '#9e9e9e ' }}>Tracking on demand mode</Typography>
            <div className={classes.accordionDetailsItem}>
              <Controller
                control={control}
                name="type"
                render={({ field }) => (
                  <>
                    <label htmlFor="type-select" style={{ marginBottom: '-14px', color: 'gray', fontSize: '12px' }}>
                      On demand tracking mode
                    </label>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue=""
                      isSearchable={true}
                      name="type"
                      options={odometerOptions}
                      value={odometerOptions.find((option) => option.id === field.value)}
                      onChange={(selectedOption) => field.onChange(selectedOption ? selectedOption.id : null)}
                    />
                  </>
                )}
              />
            </div>
          </AccordionDetails>

          <AccordionActions style={{ cursor: 'pointer' }}>
            <Button
              size="small"
              color="primary"
              title="Changes will apply to the device"
              type="submit"
              disabled={Object.keys(errors).length > 0 || loading}
            >
              <SendIcon />
            </Button>
          </AccordionActions>
        </Accordion>
      </form>
    </div>
  );
};

export default TrackingOnDemandMode;

TrackingOnDemandMode.propTypes = {
  trackingOnDemandModeRecord: PropTypes.array
};
